var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        title: "选择产品",
        width: "1080px",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _c("div", { staticClass: "select-wechat-container" }, [
        _c(
          "div",
          { staticClass: "left-panel" },
          [
            _c(
              "el-form",
              { ref: "form", attrs: { model: _vm.params, inline: "" } },
              [
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-input",
                      {
                        attrs: { placeholder: "请输入关键词", clearable: "" },
                        on: { clear: _vm.searchBtn },
                        model: {
                          value: _vm.params.keyWord,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.params,
                              "keyWord",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "params.keyWord",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "150px" },
                            attrs: { slot: "prepend", placeholder: "请选择" },
                            slot: "prepend",
                            model: {
                              value: _vm.params.keyType,
                              callback: function ($$v) {
                                _vm.$set(_vm.params, "keyType", $$v)
                              },
                              expression: "params.keyType",
                            },
                          },
                          _vm._l(_vm.keywordTypeArr, function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: item.label, value: item.value },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.searchBtn },
                      },
                      [_vm._v("查询")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("el-s-table", {
              ref: "table",
              attrs: { columns: _vm.columns, data: _vm.list, "row-key": "id" },
              on: {
                select: _vm.handleSelect,
                "select-all": _vm.handleSelectALL,
              },
            }),
            _vm._v(" "),
            _vm.total > _vm.pageSize
              ? _c(
                  "div",
                  { staticClass: "pagebox" },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.page,
                        "page-sizes": [10, 20, 30, 40],
                        "page-size": _vm.pageSize,
                        layout: "sizes, prev, pager, next, jumper",
                        total: _vm.total,
                        background: "",
                      },
                      on: {
                        "size-change": _vm.handleSizeChange,
                        "current-change": _vm.handleCurrentChange,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "vertical-divider" }),
        _vm._v(" "),
        _c("div", { staticClass: "right-panel" }, [
          _c("div", { staticClass: "selected-title" }, [
            _vm._v("已选择（" + _vm._s(_vm.selectedRows.length) + "）"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "selected-list" },
            _vm._l(_vm.selectedRows, function (item) {
              return _c(
                "div",
                { key: item.id, staticClass: "item-tag" },
                [
                  _c(
                    "el-tag",
                    {
                      attrs: { closable: "" },
                      on: {
                        close: function ($event) {
                          return _vm.handleTagClose(item)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(item.productName) +
                          "\n          "
                      ),
                    ]
                  ),
                ],
                1
              )
            }),
            0
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("取消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleConfirm } },
            [_vm._v("确认")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }